/* eslint-disable */
export default {
  all: 'Todos',
  company: 'Empresa',
  personal: 'Personal',
} as const;

// @key: @#@"all"@#@ @source: @#@"All"@#@
// @key: @#@"company"@#@ @source: @#@"Company"@#@
// @key: @#@"personal"@#@ @source: @#@"Personal"@#@
